import axios from 'axios';
import { toast } from 'react-toastify';


const instanciaAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Guard para evitar multiples toasts/redirects simultaneos
let _sesionCerrandose = false;

instanciaAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config; 
  },
  (error) => {
    return Promise.reject(error);
  }
);

instanciaAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorMsg = error.response?.data?.error || '';

    // Solo cerrar sesion si es un error de AUTENTICACION (no de permisos).
    // 401 = no autenticado
    // 403 con "Token no activo" o "Token inválido o expirado" = sesion expirada
    // 403 con "Permisos insuficientes" = permiso denegado (NO cerrar sesion)
    const esErrorAutenticacion = status === 401
      || (status === 403 && ['Token no activo', 'Token inválido o expirado']
          .some(msg => errorMsg.includes(msg)));

    if (esErrorAutenticacion && !_sesionCerrandose) {
      _sesionCerrandose = true;
      toast.error("Tu sesión ha expirado. Inicia sesión nuevamente.");

      setTimeout(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('lastActivity');
        localStorage.removeItem('permisos');
        window.location.href = '/';
        _sesionCerrandose = false;
      }, 2000);
    }

    // Manejo centralizado de 403 "Permisos insuficientes"
    // Muestra un toast claro y marca el error para que los componentes no dupliquen el mensaje
    if (status === 403 && errorMsg === 'Permisos insuficientes') {
      const faltantes = error.response?.data?.permisos_faltantes;
      const detalle = faltantes?.length
        ? ` (${faltantes.join(', ')})`
        : '';
      toast.warning(`No tienes permiso para realizar esta acción${detalle}`, { autoClose: 6000 });
      error._permisoDenegado = true;
    }

    return Promise.reject(error);
  }
);

/**
 * Verifica si un error de Axios fue manejado por el interceptor como permiso denegado.
 * Usar al inicio de bloques catch para evitar doble-toast:
 *   catch (error) { if (esErrorPermiso(error)) return; ... }
 */
export function esErrorPermiso(error) {
  return error?._permisoDenegado === true;
}

export default instanciaAxios;
